import React from 'react';
import { ViewMode } from '../lib/router';
import './Footer.css';

interface FooterProps {
  onNavigate: (view: ViewMode) => void;
}

export const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
  return (
    <footer className="app-footer">
      <div className="app-footer-links">
        <button className="app-footer-link" onClick={() => onNavigate('privacy')}>
          Privacy Policy
        </button>
        <span className="app-footer-divider">•</span>
        <button className="app-footer-link" onClick={() => onNavigate('terms')}>
          Terms of Service
        </button>
      </div>
      <div className="app-footer-copy">
        © {new Date().getFullYear()} Euro Hunting Simulator
      </div>
    </footer>
  );
};
